import { enableProdMode, ErrorHandler, importProvidersFrom } from '@angular/core';
import { environment } from './environments/environment';
import { AppComponent } from './app/app.component';
import { AngularResizeEventModule } from '@msi/angular-resize-event';
import { MatToolbarModule } from '@angular/material/toolbar';
import {
	AccordionModule,
	AccordionItemModule,
	AnchorLinksModule,
	AutocompleteV2Module,
	BadgeModule,
	CalendarModule,
	CardModule,
	CheckboxModule,
	ContentModalModule,
	DataTableModule,
	DropdownModule,
	IconModule,
	InputGroupModule,
	ModalModule,
	PopUpModalModule,
	RadioButtonModule,
	SelectModule,
	SidebarModule,
	SidenavModule,
	SliderModule,
	SpinnerModule,
	TabsModule,
	TableModule,
	TagModule,
	TimePickerControlModule,
	ToggleModule,
	TooltipModule,
	TranslocoRootModule,
	TreeviewModule,
} from '@msi/cobalt';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { routes } from './app/app.routes';
import { provideRouter, withPreloading } from '@angular/router';
import { OverlayModule } from '@angular/cdk/overlay';
import { ObserversModule } from '@angular/cdk/observers';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { BrowserModule, bootstrapApplication } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import {
	CanDeactivateGuard,
	DemoEnvironmentGuard,
	ProdEnvironmentGuard,
} from './app/services/routeGuard/route-guard.service';
import { GlobalErrorHandlerService } from './app/services/global-error-handler/global-error-handler.service';
import { TokenInjectionService } from './app/services/auth/token-injection.service';
import { HTTP_INTERCEPTORS, withInterceptorsFromDi, provideHttpClient } from '@angular/common/http';
import { appConfig } from './app/configuration/app.config';
import { AppSpecificConfigToken, CommandCentralHeaderComponentsModule } from '@msi/commandcentral-common-header';
import { CustomPreloadingStrategy } from './app/utils/preloading-strategy/preloading-strategy.utils';

if (environment.production) {
	enableProdMode();
}

bootstrapApplication(AppComponent, {
	providers: [
		importProvidersFrom(
			BrowserModule,
			DragDropModule,
			FormsModule,
			ReactiveFormsModule,
			ObserversModule,
			OverlayModule,
			ScrollingModule,
			// Cobalt modules
			AccordionModule,
			AccordionItemModule,
			AnchorLinksModule,
			AutocompleteV2Module,
			BadgeModule,
			CalendarModule,
			CardModule,
			CheckboxModule,
			ContentModalModule,
			DataTableModule,
			DropdownModule,
			IconModule,
			InputGroupModule,
			ModalModule,
			PopUpModalModule,
			RadioButtonModule,
			SelectModule,
			SidebarModule,
			SidenavModule,
			SliderModule,
			SpinnerModule,
			TabsModule,
			TableModule,
			TagModule,
			TimePickerControlModule,
			ToggleModule,
			TooltipModule,
			TranslocoRootModule,
			TreeviewModule,
			// Material modules
			MatToolbarModule,
			// Other third party modules
			AngularResizeEventModule,
			CommandCentralHeaderComponentsModule
		),
		{
			provide: AppSpecificConfigToken,
			useValue: appConfig.appSpecificConfig,
		},
		{
			provide: HTTP_INTERCEPTORS,
			useClass: TokenInjectionService,
			multi: true,
		},
		{
			provide: ErrorHandler,
			useClass: GlobalErrorHandlerService,
		},
		CanDeactivateGuard,
		DemoEnvironmentGuard,
		ProdEnvironmentGuard,
		CustomPreloadingStrategy,
		provideAnimations(),
		provideHttpClient(withInterceptorsFromDi()),
		provideRouter(routes, withPreloading(CustomPreloadingStrategy)),
	],
});

// Copyright (c) Motorola Solutions Inc. All Rights Reserved.
